import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Lack of interest</div>
                                            <p>If we don’t want to do something we’ll avoid it if we can, or get
                                                someone else to do it. In the
                                                following pages, you’ll discover ways to motivate people by
                                                linking their personal goals to those
                                                of the team, or the organisation.</p>
                                            <div className="border_subtitle">Lack of time</div>
                                            <p>You’d be surprised, but if you look closely you’ll notice how
                                                unproductive ‘busy’ people can be!
                                                We’ll talk about this later, too.</p>
                                            <div className="border_subtitle">Lack of expertise</div>
                                            <p>Expertise, knowledge – they’re words that frighten a lot of us.
                                                Usually, you’ll discover you only
                                                need to focus on what is specific to the task in hand, and it’s
                                                often easily available. We’ll describe
                                                how to find it.</p>
                                            <div className="border_subtitle">Not knowing how to take
                                                responsibility
                                            </div>

                                            <p style={{paddingBottom: '16px'}}>You may be willing to take
                                                responsibility, but not sure how to or how to persuade others
                                                that you
                                                are. We’ll guide you.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>FEAR OF FAILURE
                                            </div>
                                            <div className="border_subtitle">Step 1 – Identify</div>
                                            <p>Take some time to think about what it is, exactly, that you’re
                                                frightened of. Write it down, all of it.
                                                Once it’s defined, it’s easier to tackle.</p>
                                            <div className="border_subtitle">Step 2 – Evaluate</div>
                                            <p>Is your fear irrational? Again, write down exactly what might
                                                happen if you did fail. Will you have
                                                to leave the country? Will it be the main item on the ten
                                                o’clock news? Or, are you just telling
                                                yourself it’ll confirm all the negative self-talk that’s been
                                                going on since you let in that penalty,
                                                when you were eleven? We’re often our own harshest critics.
                                                Consider whether you would be as
                                                critical of a friend who failed at this task – then, treat
                                                yourself in the same way.</p>
                                            <p>Here are some ways to get fears in proportion:</p>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink uiheading ilead_v_sport_center uiheading">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top"
                                                        className="green_curve green_curve1"
                                                        colSpan="2">Challenging Your Worries
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Keep a journal</p>
                                                    </td>
                                                    <td width="80%" align="left" valign="top"
                                                        className="lightgreen"><p>Jot down what’s worrying you.
                                                        In a few days or weeks, write the outcome.
                                                        Things usually work out better than we imagined.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Focus on now</p>
                                                    </td>
                                                    <td width="80%" align="left" valign="top"
                                                        className="lightgreen"><p>The next time a thought
                                                        threatens to escalate into anxiety, bring yourself
                                                        back into ‘now’. Snap your fingers, focus on your
                                                        breathing or do something
                                                        else to distract yourself.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>So, prove
                                                        you’re a failure</p>
                                                    </td>
                                                    <td width="80%" align="left" valign="top"
                                                        className="lightgreen"><p>Visualise important events
                                                        during the last 10 years. In most cases we can’t
                                                        remember how we worried about them beforehand. Even if
                                                        you do
                                                        remember a little, it’ll help to prove that things
                                                        generally turn out well. Tell
                                                        yourself that what’s worrying you now will fade away,
                                                        too.</p>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>


                                            <div className="border_subtitle">Step 3 – Re-interpret</div>
                                            <p>If you think a thought often enough, it becomes a belief. Try to
                                                work through the layers of your fear
                                                and find what the root of it really is. Is it, in fact, just
                                                that you really, really want to succeed and are
                                                uncertain how to ensure you do? Or, is it something someone else
                                                has said, or experienced, which
                                                you have ‘taken on board’?</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}